import TeamLogo from './TeamLogo';
import { TeamLogoProps, TeamLogoValueProps } from './types';

export type { TeamLogoProps, TeamLogoValueProps };
export default TeamLogo;
